import React from "react";
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { useRecoilValue } from 'recoil';
import { refProjectIdState } from 'atoms/projectData';

// ラスター名入力モーダル
const UploadRasterNameModal = (props) => {
  const {
    rasterNameInputModalIsOpen,
    handleClickRasterNameInputModalClose,
    handleClickRasterNameInput,
    handleClickRasterDataPutS3,
    rasterEditDeleteState,
    handleClickRasterEditModalClose,
    handleClickUpdateRaster,
    handleClickDeleteRaster,
    handleClickRasterNameUpdateInput,
    upDateRasterName,
    handleChangeSelectRasterFile
  } = props;

  // Recoilから取得
  const projectId = useRecoilValue(refProjectIdState); // コピー元
  
  // 編集削除モーダルの表示制御
  const isEditDeleteDialogOpen = rasterEditDeleteState.rasterId !== ""; // ラスターIDがからの場合は非表示
  const isUpdateFlag = upDateRasterName !== ""; // ラスター名が空の場合は更新ボタンを非活性

  return (
    <>
      {/* 新規登録モーダル */}
      <Dialog
        maxWidth="lg"
        open={rasterNameInputModalIsOpen}
        onClose={() => handleClickRasterNameInputModalClose()}
      >
        <Box p={3}>
          <Box mb={2}>追加レイヤー名を入力してください</Box>
          <Box style={{ display: "flex" }}>
            <TextField id="outlined-basic" label="追加レイヤー名" variant="outlined" style={{ minWidth: "350px" }} onChange={(e) => handleClickRasterNameInput(e.target.value)} />
            <Button style={{ marginLeft: "15px" }} variant="contained" color="primary" onClick={handleClickRasterDataPutS3}><ControlPointIcon /></Button>
          </Box>
        </Box>
      </Dialog>

      {/* 編集削除モーダル */}
      <Dialog
        maxWidth="lg"
        open={isEditDeleteDialogOpen}
        onClose={() => handleClickRasterEditModalClose()}
      >
        <Box p={3}>
          <Box mb={2.5} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{fontSize: "16px"}}>{rasterEditDeleteState.rasterName}の編集</div>
            <Button onClick={handleClickRasterEditModalClose}><HighlightOffIcon/></Button>
          </Box>
          <Box mb={2.5} style={{ display: "flex" }}>
            <TextField id="outlined-basic" defaultValue={upDateRasterName} label="追加レイヤー名" variant="outlined" style={{ minWidth: "350px" }} onChange={(e) => handleClickRasterNameUpdateInput(e.target.value)} />
          </Box>
          <Box mb={2.5} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <input
              type="file" accept=".zip,.geojson"
              onChange={(e) => handleChangeSelectRasterFile(e, "update")}
            />
          </Box>
          <Box style={{ textAlign: "right" }}>
            <Button style={{ fontSize: "16px", marginRight: "10px" }} variant="contained" onClick={() => {handleClickDeleteRaster(rasterEditDeleteState.rasterId, projectId, rasterEditDeleteState.rasterName)}}>削除</Button>
            <Button style={{ fontSize: "16px" }} variant="contained" color="primary" onClick={handleClickUpdateRaster} disabled={!isUpdateFlag}>更新</Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}

export default React.memo(UploadRasterNameModal);